import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

// Single required-confirmation control (DESIGN.md "Custom checkbox" spec) — a real
// <button aria-pressed> toggle, not a native <input type="checkbox">. First real
// consumer: story e8-4's BaselinePackageStepComponent.
@Component({
  selector: 'app-confirmation-checkbox',
  templateUrl: './confirmation-checkbox.component.html',
  styleUrls: ['./confirmation-checkbox.component.scss'],
  standalone: false,
})
export class ConfirmationCheckboxComponent implements OnInit {
  @Input() control: FormControl<boolean>
  @Input() label: string
  @Input() required: boolean = false
  @Input() errorText: string

  id: string
  errorId: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
    this.errorId = `${this.id}-error`
  }

  get isInvalid(): boolean {
    return (
      this.required &&
      this.control?.invalid === true &&
      this.control?.touched === true
    )
  }

  toggle(): void {
    this.control?.setValue(!this.control.value)
    this.control?.markAsTouched()
  }
}
